module.exports = __webpack_public_path__ + "assets/language-squares/de-9fc4defab9009feeb1b3d74179fd32f2.jpg";